import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import APP_CONFIG from "../../app/app.config";

import * as $ from "jquery";

/*
  Generated class for the RoomProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RoomProvider {

  constructor(public http: HttpClient) {
    console.log('Hello RoomProvider Provider');
  }

  /**
   *
   */
  list(params = {}) {
    params = $.param(params);
    return  this.http.get(`${APP_CONFIG.baseURL}/rooms/list?${params}`);
  }

  /**
   *
   */
  detail(id = 0) {
    return  this.http.get(`${APP_CONFIG.baseURL}/rooms/detail/id/${id}`);
  }

  /**
   *
   */
  connect(id = 0) {
    return  this.http.get(`${APP_CONFIG.baseURL}/rooms/connect/id/${id}`);
  }

  /**
   *
   * @param body
   */
  save(body) {
    return  this.http.post(`${APP_CONFIG.baseURL}/rooms/save`, body);
  }

  /**
   *
   * @param id
   */
  remove(id) {
    return  this.http.delete(`${APP_CONFIG.baseURL}/rooms/remove/id/${id}`);
  }

  /**
   *
   * @param id
   */
  remove_user(id) {
    return  this.http.delete(`${APP_CONFIG.baseURL}/rooms/remove_user/id/${id}`);
  }

}



// WEBPACK FOOTER //
// ./src/providers/room/room.ts